/** tempexp_14728-full-file */
import React, { FC } from 'react';

import { TrashbinItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox/Checkbox';
import { Date } from '../Date/Date';
import { Destination } from '../Destination/Destination';
import { ItemName } from '../ItemName/ItemName';
import { Pic } from '../Pic/Pic';
import { Restore } from '../Restore/Restore';
import { Size } from '../Size/Size';
import { TableColumn } from '../TableColumn/TableColumn';

interface TrashbinProps extends TrashbinItemProps {
    checkboxClassname?: string;
}

export const Trashbin: FC<TrashbinProps> = (props) => {
    const path = props.deletedFrom === '/' ? props.binName : props.deletedFrom.slice(0, props.deletedFrom.length - 1);

    return (
        <>
            <TableColumn>
                <Checkbox className={props.checkboxClassname} onCheckboxClick={props.onCheckboxClick} isSelected={props.isSelected} />
                <Pic isFolder={props.isFolder} thumbUrl={props.thumbUrl} isVirus={false} ext={props.ext || ''} kind={props.kind} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <Destination destination={path} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                <Date date={props.deletedAt} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Restore onClick={props.onRestore} />
            </TableColumn>
        </>
    );
};
